<mat-card>
  <h2 translate>pointOfSale.title</h2>
  <form [formGroup]="pointOfSaleDataForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="100" fxFlex.gt-sm="50">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="establishment"
          [id]="'establishment'"
          [dataInput]="establishmentData"
          [placeholder]="'pointOfSale.establishment'"
          [isRequired]="true"
          [showErrors]="pointOfSaleDataForm?.controls?.establishment?.errors"
        >
        </scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field monthYearDayDirective fxFlex="100" appearance="outline">
          <mat-label translate>pointOfSale.requestDate</mat-label>
          <input
            id="requestDate"
            matInput
            maxlength="10"
            [matDatepicker]="datepicker"
            formControlName="requestDate"
            [min]="currentDate"
            [max]="maxRequestDate"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
          <mat-datepicker #datepicker></mat-datepicker>
          <mat-error
            *ngIf="
              pointOfSaleDataForm.controls.requestDate.hasError('required') &&
              !pointOfSaleDataForm.controls.requestDate.hasError('matDatepickerParse')
            "
            translate
          >
            field.required
          </mat-error>
          <mat-error *ngIf="pointOfSaleDataForm.controls.requestDate.hasError('matDatepickerMax')" translate>
            field.error.maxDate
          </mat-error>
          <mat-error *ngIf="pointOfSaleDataForm.controls.requestDate.hasError('matDatepickerMin')" translate>
            field.error.minDateToCurrent
          </mat-error>
          <mat-error *ngIf="pointOfSaleDataForm.controls.requestDate.hasError('matDatepickerParse')" translate>
            field.error.parseDate
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="50">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="vendor"
          [id]="'vendor'"
          [dataInput]="vendorData"
          [placeholder]="'pointOfSale.vendor'"
          [isRequired]="true"
          [mode]="mode"
          [showErrors]="pointOfSaleDataForm?.controls?.vendor?.errors"
          (selectionChange)="onChangeVendor()"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="requestLanguage"
          [id]="'requestLanguage'"
          [dataInput]="languages"
          [placeholder]="'pointOfSale.requestLanguage'"
          [isRequired]="true"
          [hasToTranslateValue]="true"
          [showErrors]="pointOfSaleDataForm?.controls?.requestLanguage?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25" *ngIf="isBP">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="inputChannel"
          [id]="'inputChannel'"
          [dataInput]="inputChannels"
          [placeholder]="'pointOfSale.inputChannel'"
          [isRequired]="true"
          [hasToTranslateValue]="true"
          [showErrors]="pointOfSaleDataForm?.controls?.inputChannel?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25" *ngIf="isMG">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="inputChannel"
          [id]="'inputChannel'"
          [dataInput]="inputChannels"
          [placeholder]="'pointOfSale.inputChannel'"
          [isRequired]="true"
          [hasToTranslateValue]="true"
          [showErrors]="pointOfSaleDataForm?.controls?.inputChannel?.errors"
        ></scf-custom-select-search>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="40" *ngIf="isMG || isMgWithShopping">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>pointOfSale.employeeInternalRefMG</mat-label>
          <input id="employeeInternalRefMG" formControlName="employeeInternalRefMG" matInput autocomplete="off" />
          <mat-error
            *ngIf="pointOfSaleDataForm.controls.employeeInternalRefMG.hasError('employeeCodeInvalid')"
            translate
          >
            field.employeeMg
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="20" *ngIf="isMG">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="employeeMG"
          [id]="'employeeMG'"
          [dataInput]="employeeMGData"
          [placeholder]="'pointOfSale.employeeMG'"
          [isRequired]="true"
          [hasToTranslateValue]="true"
          [showErrors]="pointOfSaleDataForm?.controls?.employeeMG?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="40" *ngIf="isMG || isMgWithShopping">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>pointOfSale.idStoreMG</mat-label>
          <input id="idStoreMG" formControlName="idStoreMG" matInput autocomplete="off" />
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>
